import { useState, useRef, useEffect } from 'react';
import { isImageCached, markImageAsLoaded } from '../../utils/imageCache';

export const useImageLoad = (src: string | undefined) => {
  const wasCached = useRef(src ? isImageCached(src) : false);
  const [imageLoaded, setImageLoaded] = useState(wasCached.current);
  const previousSrc = useRef(src);

  useEffect(() => {
    if (src !== previousSrc.current) {
      previousSrc.current = src;
      wasCached.current = src ? isImageCached(src) : false;
      setImageLoaded(wasCached.current);
    }
  }, [src]);

  const handleImageLoad = () => {
    if (src) markImageAsLoaded(src);
    setImageLoaded(true);
  };

  return { 
    imageLoaded, 
    handleImageLoad, 
    wasCached: wasCached.current 
  };
};